/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import Moment from "moment";
import React, { Component } from "react";
import { Button, ButtonToolbar, Modal, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { NoticeContentManagementSystem } from "../../../../_metronic/_partials/controls";
import AppConfig from "../../../config/AppConfig";

class ContentManagementSystem extends Component {
  constructor(props, context) {
    super(props, context);
    this.modalDetail = this.modalDetail.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  state = {
    sessiondata: JSON.parse(localStorage.getItem("sessiondata")),
    loadingList: true,
    loadingDetails: false,
    list_informasi: [],
    detail_informasi: [],
    data_lampiran: [],
    file: "",
    nm_file: "",
    // MODAL ============================
    modalDetail: false,
    // paging
    keyword: "",
    totalData: 0,
    totalPaginationNumber: 0,
    limit: 10,
    start: 0,
    currentPage: 1,
    pageLimit: 5,
    showFrom: 0,
  };

  handleClose() {
    this.setState({
      modalDetail: false,
    });
  }

  componentDidMount() {

    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

    if(sessiondata.i_idrole !== 10 && sessiondata.i_idrole !== 2014) {
       window.location.href = "/"; 
    }

    this.setState({ loadingList: true });

    var formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    formData.append("data[id_pembina]", this.state.sessiondata.i_idunit);
    formData.append("data[id_role]", this.state.sessiondata.i_idrole);
    axios
      .post(
        AppConfig.ListInformasi +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start,
        formData
      )
      .then((res) => {
        console.log(res.data.result);
        this.setState(
          {
            loadingList: false,
            list_informasi: res.data.result.data,
            // data_lampiran: {
            //   base64: res.data.result.lampiran,
            //   nm_lampiran: res.data.result.nm_lampiran,
            // },
            totalData: res.data.result.total_rows,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          },
          () => {
            console.log(this.state.list_informasi);
            console.log(this.state.data_lampiran);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  modalDetail(id) {
    this.setState({ modalDetail: true, loadingDetails: true });
    axios
      .get(AppConfig.EditInformasi + id)
      .then((res) => {
        console.log(res.data.result);
        this.setState({
          loadingDetails: false,
          detail_informasi: {
            judul: res.data.result.data_konten.judul,
            isi_konten: res.data.result.data_konten.isi_konten,
          },
          file: res.data.result.data_lampiran?.konten_dokumen,
          nm_file: res.data.result.data_lampiran?.filename,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deleteContent(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      icon: "warning",
      title: "Hapus data?",
      text: "Data yang dihapus tidak dapat dikembalikan",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(AppConfig.DeleteInformasi + id + session)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
          });
      } else {
        swal({
          icon: "error",
          title: "Dibatalkan!",
          text: "Anda membatalkan operasi",
          button: "OK!",
        });
      }
    });
  }

  downloadPDF(file) {
    const linkSource = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = this.state.nm_file;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  render() {
    let no = 0;

    return (
      <>
        <NoticeContentManagementSystem
          style={{ marginBottom: "0px", boxShadow: "none" }}
        >
          <strong style={{ fontSize: "18px" }}>
            Content Management System
          </strong>
          <p>Daftar Informasi</p>
        </NoticeContentManagementSystem>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "12px" }}>
            <div className="col-md-4 text-left"></div>
            <div className="col-md-4 text-center">
              <strong style={{ fontSize: "18px" }}>Table Informasi</strong>
            </div>
            <div className="col-md-4 text-right">
              <Link to="/add-content">
                <Button
                  variant="primary"
                  style={{
                    padding: "12px",
                    width: "50%",
                  }}
                >
                  <i
                    className="flaticon-add"
                    style={{ color: "#ffffff", fontSize: "14px" }}
                  ></i>
                  &nbsp; Tambah Informasi Baru
                </Button>
              </Link>
            </div>
          </div>
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "left",
                  }}
                >
                  Judul Informasi
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "left",
                  }}
                >
                  Deskripsi
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Tanggal Pembuatan
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Dibuat Oleh
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  Ditujukan Untuk
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                    width: "auto",
                    minWidth: "200px",
                  }}
                >
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingList === true ? (
                <tr>
                  <td colSpan="7">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : this.state.list_informasi.length > 0 ? (
                this.state.list_informasi.map((list, idx) => (
                  <tr key={list.id_konten}>
                    <td style={{ verticalAlign: "top", textAlign: "center" }}>
                      {(no = no + 1)}
                    </td>
                    <td style={{ verticalAlign: "top" }}>{list.judul}</td>
                    <td style={{ verticalAlign: "top" }}>{list.deskripsi}</td>
                    <td style={{ verticalAlign: "top", textAlign: "center" }}>
                      {Moment(list.updated_at).format("DD MMMM YYYY")}
                    </td>
                    <td style={{ verticalAlign: "top", textAlign: "center" }}>
                      {list.nm_pembina !== "null"
                        ? list.nm_pembina
                        : list.nm_updater}
                    </td>
                    <td style={{ verticalAlign: "top", textAlign: "center" }}>
                      {list.id_viewer === 0 || list.id_viewer === "null"
                        ? "Semua"
                        : list.id_viewer === 3
                        ? "Admin PT"
                        : "Reviewer SPMI"}
                    </td>
                    <td style={{ verticalAlign: "top", textAlign: "center" }}>
                      <ButtonToolbar
                        onClick={() => this.modalDetail(list.id_konten)}
                        className="btn btn-icon btn-primary btn-sm"
                        style={{
                          minWidth: "50px",
                          marginRight: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <div>
                          <i
                            className="flaticon-eye"
                            style={{ color: "#FFFFFF", fontSize: "14px" }}
                          ></i>
                        </div>
                      </ButtonToolbar>
                      <Link to={`/edit-content/${list.id_konten}`}>
                        <ButtonToolbar
                          // onClick={() => this.modalURole(list.result.id_pengguna)}
                          className="btn btn-icon btn-info btn-sm"
                          style={{
                            minWidth: "50px",
                            borderRadius: "12px",
                          }}
                        >
                          <div>
                            <i
                              className="flaticon2-edit"
                              style={{ color: "#FFFFFF", fontSize: "14px" }}
                            ></i>
                          </div>
                        </ButtonToolbar>
                      </Link>
                      <ButtonToolbar
                        onClick={() => this.deleteContent(list.id_konten)}
                        className="btn btn-icon btn-danger btn-sm"
                        style={{
                          minWidth: "50px",
                          marginLeft: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <div>
                          <i
                            className="flaticon2-trash"
                            style={{ color: "#FFFFFF", fontSize: "14px" }}
                          ></i>
                        </div>
                      </ButtonToolbar>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>

        {/*========================================== Begin Modal Detail ========================================== */}
        <Modal
          size="lg"
          show={this.state.modalDetail}
          onHide={this.handleClose}
          keyboard={false}
        >
          <Modal.Body>
            {this.state.loadingDetails === true ? (
              <>
                <div className="row">
                  <div className="col-md-12">
                    <LinearProgress color="secondary" variant="query" />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="text-center">
                  <strong style={{ fontSize: "18px" }}>
                    {this.state.detail_informasi.judul}
                  </strong>
                </div>
                <div
                  className="p-5 text-justify"
                  dangerouslySetInnerHTML={{
                    __html: this.state.detail_informasi.isi_konten,
                  }}
                ></div>
                <div className="text-left">
                  <span>Lampiran : </span>
                  {this.state.nm_file === undefined ? (
                    <span>
                      <i style={{ fontSize: "12px" }}>Tidak ada lampiran</i>
                    </span>
                  ) : (
                    <a
                      href="#"
                      onClick={() => this.downloadPDF(this.state.file)}
                    >
                      {this.state.nm_file}
                    </a>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
        {/*========================================== End Modal Detail ========================================== */}
      </>
    );
  }
}
export default ContentManagementSystem;
